/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedIconBubbleEmail_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubbles_viewer$ref: FragmentReference;
export type PdpRespIconBubbles_viewer = {|
  +isPinterestShareEnabled: ?boolean,
  +isFacebookShareEnabled: ?boolean,
  +$fragmentRefs: PdpSharedIconBubbleEmail_viewer$ref,
  +$refType: PdpRespIconBubbles_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isPinterestShareEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "PINTEREST_SHARE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFacebookShareEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FACEBOOK_SHARE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c390af53d1b2b0a80836606a1b9520e0';
module.exports = node;
